<template>
  <div class="text-center">
    <v-dialog
      width="500"
      @click="modalReject"
      :value="isOpenModal"
      @click:outside="modalReject"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          お問い合わせ内容確認
        </v-card-title>
        <br />
        <v-card-subtitle>
          以下の内容でお問い合わせを行ってもよろしいでしょうか？
        </v-card-subtitle>
        <v-card-text> 名前：{{ user.name }} </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-6"> 企業名：{{ inquiry.company }} </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          メールアドレス：{{ user.email }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          お問い合わせの種類：{{ inquiry_type[inquiry.inquiry_type] }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          お問い合わせ内容：{{ inquiry.inquiry_contents }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          個人情報の取扱いについて：同意する
        </v-card-text>
        <v-divider></v-divider>
        <!-- <v-card class="mt-6">
          <img
            class="preview-item-file"
            :src="imageUrl"
          />
        </v-card>
        <v-divider></v-divider> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="modalReject"> 戻る </v-btn>
          <v-btn
            color="primary"
            text
            @click="modalResolve"
            :loading="loading"
            type="submit"
          >
            お問い合わせを送信
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      height: 500,
      inquiry_type: {
        1: "機能について",
        2: "不具合報告",
        3: "導入について",
        4: "料金について",
        99: "その他",
      },
    };
  },
  name: "props",
  props: ["inquiry", "user", "imageUrl"],
  computed: {
    isOpenModal() {
      return this.$store.getters["inquiryModal/isOpen"];
    },
  },
  methods: {
    modalReject() {
      this.$store.dispatch("inquiryModal/actionModalReject", false);
    },
    modalResolve() {
      this.loading = true;
      this.$store.dispatch("inquiryModal/actionModalResolve", true);
    },
  },
};
</script>